(function ($) {
    $('.bio-toggle').click(function(){
        $(this).parent().toggleClass('display-bio');
    });

})(jQuery);